<template>
  <div class="ll-password-setting-card">
    <form>
      <slot />
    </form>
  </div>
</template>
<script>
export default {
  name: "LlPasswordSettingCard",
  data: () => ({}),
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-password-setting-card";
</style>